import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.pagination || initialState;

export const selectPaginationLimit = createSelector(
  [selectSlice],
  state => state.limit,
);
export const selectPaginationOffset = createSelector(
  [selectSlice],
  state => state.offset,
);
export const selectPaginationPage = createSelector(
  [selectSlice],
  state => state.page,
);
export const selectPaginationTotalPages = createSelector(
  [selectSlice],
  state => state.totalPages,
);
export const selectPaginationTotalItemsCount = createSelector(
  [selectSlice],
  state => state.totalItemsCount,
);
